"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAnonymousUser = exports.defaultRequestPagination = void 0;
exports.defaultRequestPagination = {
    page: 1,
    limit: 50,
};
exports.defaultAnonymousUser = {
    type: 'anonymousUser',
};
/**
 * End of Auth related types
 */
